module.exports = __webpack_public_path__ + "static/media/task1Planet1.a922c01e.png";